<template>
  <!--Loader default display flex-->
  <div class="cn-shimmer-loader" style="display:flex;">
    <div class="cn-shimmer_block">
      <div class="cn-shimmer-img cn-animate">&nbsp;</div>
      <div class="cn-shimmer-con">
        <div class="cn-shimmer-header">
          <div class="cn-shimmer-header-left">
            <span class="cn-shimmer-pro-img cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-header-cen">
            <h3 class="cn-animate">&nbsp;</h3>
            <span class="cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-header-right">
            <span class="cn-social-ico cn-animate">&nbsp;</span>
          </div>
        </div>

        <div class="cn-shimmer-body">
          <p class="cn-animate">&nbsp;</p>
          <p class="cn-animate">&nbsp;</p>
          <p class="cn-animate last">&nbsp;</p>
        </div>
        <div class="cn-shimmer-footer">
          <div class="cn-shimmer-footer-left">
            <span class="cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-footer-right">
            <ul class="cn-social-links">
              <li class="cn-animate">&nbsp;</li>
              <li class="cn-animate">&nbsp;</li>
              <li class="cn-animate">&nbsp;</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="cn-shimmer_block">
      <div class="cn-shimmer-img cn-animate">&nbsp;</div>
      <div class="cn-shimmer-con">
        <div class="cn-shimmer-header">
          <div class="cn-shimmer-header-left">
            <span class="cn-shimmer-pro-img cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-header-cen">
            <h3 class="cn-animate">&nbsp;</h3>
            <span class="cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-header-right">
            <span class="cn-social-ico cn-animate">&nbsp;</span>
          </div>
        </div>

        <div class="cn-shimmer-body">
          <p class="cn-animate">&nbsp;</p>
          <p class="cn-animate">&nbsp;</p>
          <p class="cn-animate last">&nbsp;</p>
        </div>
        <div class="cn-shimmer-footer">
          <div class="cn-shimmer-footer-left">
            <span class="cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-footer-right">
            <ul class="cn-social-links">
              <li class="cn-animate">&nbsp;</li>
              <li class="cn-animate">&nbsp;</li>
              <li class="cn-animate">&nbsp;</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="cn-shimmer_block">
      <div class="cn-shimmer-img cn-animate">&nbsp;</div>
      <div class="cn-shimmer-con">
        <div class="cn-shimmer-header">
          <div class="cn-shimmer-header-left">
            <span class="cn-shimmer-pro-img cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-header-cen">
            <h3 class="cn-animate">&nbsp;</h3>
            <span class="cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-header-right">
            <span class="cn-social-ico cn-animate">&nbsp;</span>
          </div>
        </div>

        <div class="cn-shimmer-body">
          <p class="cn-animate">&nbsp;</p>
          <p class="cn-animate">&nbsp;</p>
          <p class="cn-animate last">&nbsp;</p>
        </div>
        <div class="cn-shimmer-footer">
          <div class="cn-shimmer-footer-left">
            <span class="cn-animate">&nbsp;</span>
          </div>
          <div class="cn-shimmer-footer-right">
            <ul class="cn-social-links">
              <li class="cn-animate">&nbsp;</li>
              <li class="cn-animate">&nbsp;</li>
              <li class="cn-animate">&nbsp;</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'shimerloader'
}
</script>
